import { MapUiTheme } from '../../common';

export const sliderTheme = {
  slides: {
    maxWidth: '100%',
    position: 'relative',
    perspective: '1000px',
    overflow: 'hidden',
  },
  slide: {
    defaultStyle: {
      position: 'absolute',
      top: 0,
      left: 0,
      listStyleType: 'none',
      width: '100%',
      height: '100%',
      outline: 'none',
      zIndex: (theme: MapUiTheme) => theme.zIndices.auto,
      '& *': {
        maxWidth: '100%',
      },
    },

    hidden: {
      visibility: 'hidden',
      zIndex: (theme: MapUiTheme) => theme.zIndices.hide,
      '*': {
        visibility: 'hidden !important',
      },
    },
  },
  controls: {
    bullet: {
      defaultStyles: {
        all: 'unset',
        cursor: 'pointer',
        borderRadius: '50%',
        height: '1rem',
        width: '1rem',
        margin: '5px',
        outline: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        position: 'relative',
        '&:focus-visibile:after': {
          content: '" "',
          position: 'absolute',
          height: '1.1rem',
          width: '1.1rem',
          top: '-0.05rem',
          left: '-0.05rem',
          background: 'transparent',
          borderRadius: '50%',
          borderWidth: '0.2rem',
          borderStyle: 'solid',
        },
        '& > span': {
          background: 'transparent',
          display: 'inline-block',
          borderRadius: '50%',
          height: '0.6rem',
          width: '0.6rem',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: (theme: MapUiTheme) => theme.colors.interaction200,
        },
        '&[aria-current="true"] > span': {
          background: (theme: MapUiTheme) => theme.colors.interaction200,
        },
      },
      primary: {
        '&:focus-visibile:after': {
          borderColor: (theme: MapUiTheme) => theme.colors.interaction200,
        },
        '& > span': {
          borderColor: (theme: MapUiTheme) => theme.colors.interaction200,
        },
        '&[aria-current="true"] > span': {
          background: (theme: MapUiTheme) => theme.colors.interaction200,
        },
      },
      secondary: {
        '&:focus-visibile:after': {
          borderColor: (theme: MapUiTheme) => theme.colors.interaction200,
        },
        '& > span': {
          borderColor: (theme: MapUiTheme) => theme.colors.interaction200,
        },
        '&[aria-current="true"] > span': {
          background: (theme: MapUiTheme) => theme.colors.interaction200,
        },
      },
      accent: {
        '&:focus-visibile:after': {
          borderColor: (theme: MapUiTheme) => theme.colors.interaction200,
        },
        '& > span': {
          borderColor: (theme: MapUiTheme) => theme.colors.interaction200,
        },
        '&[aria-current="true"] > span': {
          background: (theme: MapUiTheme) => theme.colors.interaction200,
        },
      },
    },
  },
};
